<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;Add Airline</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <form [formGroup]="airlineForm">
                <div class="row">

                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="cn">Airline Number *</label>
                            <input id="cn" class="form-control" maxlength="2" formControlName="airline_Number" placeholder="Airline Number" type="text" [ngClass]="{'is-invalid': submitted && airlineFormControls.airline_Number.errors}">
                            <div *ngFor="let validation of validation_messages.airline_Number">
                                <div class="error-message" *ngIf="airlineFormControls.airline_Number.hasError(validation.type) && ((airlineFormControls.airline_Number.dirty  || airlineFormControls.airline_Number.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="cn">Airline Name *</label>
                            <input id="cn" class="form-control" formControlName="full_Name" placeholder="Airline Name" type="text" [ngClass]="{'is-invalid': submitted && airlineFormControls.full_Name.errors}">
                            <div *ngFor="let validation of validation_messages.full_Name">
                                <div class="error-message" *ngIf="airlineFormControls.full_Name.hasError(validation.type) && ((airlineFormControls.full_Name.dirty  || airlineFormControls.full_Name.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-md-12 py-3">
                        <button id="saveAgencyBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddAirline(airlineForm.value)">Add Airline</button>
                    </div>
                </div>
                
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>